import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import '@nlocal/ui/styles/base.css'

import App from './App.vue'
import { router } from './router'
import { initObservability } from './observability'
import { useThemeStore } from './stores/theme'

const app = createApp(App)

// Before the plugins below, so a failure while they initialise is still reported.
initObservability(app, router)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // The dashboard is fed by Reverb (§15), so polling would duplicate work the
        // websocket already does. Refetch on focus for the case where the socket dropped.
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error: unknown) => {
          // Never retry an auth or permission failure — it will not resolve itself and the
          // retries just delay the redirect to /login.
          const status = (error as { response?: { status?: number } })?.response?.status
          if (status === 401 || status === 403 || status === 404) return false
          return failureCount < 2
        },
      },
    },
  },
})

// Apply the theme before mount so there is no flash of the wrong palette.
useThemeStore().apply()

app.mount('#app')
